export class filter {
  static allValues = (searchTerm, items) => {
    return (
      items &&
      items.filter(item => {
        if (!searchTerm) {
          return true
        }
        return Object.values(item)
          .map(
            value =>
              value &&
              value
                .toString()
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
          )
          .filter(value => value)[0]
      })
    )
  }
}
